import React, { useEffect, useState } from 'react';
import Badge from './Badge';

interface BadgesProps<T> {
  items: T[];
  textBuilder: (item: T) => string;
  onSelect: (item: T) => void;
  value: T | undefined;
}

export default function Badges<T>({ items, textBuilder, onSelect, value }: BadgesProps<T>) {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    if (value !== selected) setSelected(value);
  }, [value]);

  return (
    <div className='flex gap-2'>
      {items.map(item => (
        <Badge
          key={textBuilder(item)}
          text={textBuilder(item)}
          selected={selected === item}
          onClick={() => {
            setSelected(item);
            onSelect(item);
          }}
        />
      ))}
    </div>
  );
}
